import i18n from '@/libs/i18n/index'
import store from '@/store'
import useBasicToast from '@/composable/useBasicToast'
import useEntityCrud from '@/composable/useEntityCrud'
import useEntityHelper from '@/composable/useEntityHelper'
import useErrorManager from '@/composable/useErrorManager'
import { ref } from '@vue/composition-api'

export default function usePagesList() {
  const MODULE_NAME = 'pages'
  const ENDPOINT = 'pages'
  const errorManager = useErrorManager()

  const { getAlt, createTagIdArray } = useEntityHelper()
  function convertResource(resource, selectedLang) {
    return {
      ...resource,
      lang: selectedLang,
      title: resource.title[selectedLang],
      keywords: resource.keywords[selectedLang],
      description: resource.description[selectedLang],
      tags: resource.tagIds && resource.tagIds.length ? resource.tagIds.filter(itemEntry => itemEntry && itemEntry.language === selectedLang) : null,
      content: resource.content[selectedLang],
      category: resource.pageCategoryID ? { title: resource.pageCategoryID.title[selectedLang], _id: resource.pageCategoryID._id } : {},
      editor: resource.editorId ? { fullName: resource.editorId.fullName, _id: resource.editorId._id } : {},
      pageThumbnail: resource.pageThumbnailFileId[selectedLang],
      pageCoverImage: resource.pageCoverImageFileId[selectedLang],
      pageThumbnailAlt: getAlt('pageThumbnailFileId', resource, selectedLang),
      pageCoverImageAlt: getAlt('pageCoverImageFileId', resource, selectedLang),
      pageLink: { name: 'pages-pages-edit', params: { id: resource._id, lang: selectedLang } },
    }
  }
  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)

  const { itemLoading, item, form } = entity
  const isUniqueSlug = ref(true)
  const toast = useBasicToast()
  const pageCategories = ref([])

  // Table Handlers
  const tableColumns = [
    {
      key: 'title', label: i18n.t('general.title'), type: 'textImage', textKey: 'title', imageKey: 'pageThumbnail', linkKey: 'pageLink', sortable: true,
    },
    { key: 'category', label: i18n.t('general.category'), sortable: false },
    {
      key: 'pageCoverImage', label: i18n.t('pages.pageCoverImage'), sortable: false, type: 'image',
    },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), sortable: true, type: 'dateTime',
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), sortable: true, type: 'dateTime',
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  const fetchPageCategories = lang => {
    store
      .dispatch('crud/fetchList', {
        queryParams: { lang },
        endpoint: 'page-categories',
      })
      .then(response => {
        pageCategories.value = response.data.data.map(itemEntry2 => ({ _id: itemEntry2._id, title: itemEntry2.title[lang] }))
      })
      .catch(() => {
        toast({
          title: i18n.t('errors.fetchError'),
          type: 'danger',
        })
      })
  }

  const checkSlugIsUnique = (lang = 'fa', slug) => {
    if (slug === '' || (item.value && item.value.slug === form.value.slug)) {
      isUniqueSlug.value = true
      return
    }
    itemLoading.value = true
    store
      .dispatch('crud/fetchItem',
        { data: { id: slug }, queryParams: { lang }, endpoint: 'pages/slug' })
      .then(response => {
        isUniqueSlug.value = response.data.isUnique
      })
      .catch(err => {
        errorManager(err)
      })
      .finally(() => {
        const assignmentResult = false
        itemLoading.value = assignmentResult; return assignmentResult
      })
  }

  return {
    ...entity,
    checkSlugIsUnique,
    convertResource,
    createTagIdArray,
    errorManager,
    fetchPageCategories,
    isUniqueSlug,
    pageCategories,
    tableColumns,
  }
}
